import type { MessageKey } from "~/i18n";

/** Curated Composio toolkit slugs → short capability line (WhatsApp-style). */
const SLUG_TAGLINE_KEYS: Readonly<Record<string, MessageKey>> = {
  gmail: "settings.connections.toolkitTagline.gmail",
  googlecalendar: "settings.connections.toolkitTagline.googlecalendar",
  googledrive: "settings.connections.toolkitTagline.googledrive",
  googlesheets: "settings.connections.toolkitTagline.googlesheets",
  googledocs: "settings.connections.toolkitTagline.googledocs",
  googleslides: "settings.connections.toolkitTagline.googleslides",
  slack: "settings.connections.toolkitTagline.slack",
  notion: "settings.connections.toolkitTagline.notion",
  github: "settings.connections.toolkitTagline.github",
  linear: "settings.connections.toolkitTagline.linear",
  jira: "settings.connections.toolkitTagline.jira",
  discord: "settings.connections.toolkitTagline.discord",
  outlook: "settings.connections.toolkitTagline.outlook",
  hubspot: "settings.connections.toolkitTagline.hubspot",
  asana: "settings.connections.toolkitTagline.asana",
  figma: "settings.connections.toolkitTagline.figma",
  trello: "settings.connections.toolkitTagline.trello",
  zoom: "settings.connections.toolkitTagline.zoom",
  dropbox: "settings.connections.toolkitTagline.dropbox",
  airtable: "settings.connections.toolkitTagline.airtable",
  microsoft_teams: "settings.connections.toolkitTagline.microsoftTeams",
  gitlab: "settings.connections.toolkitTagline.gitlab",
  bitbucket: "settings.connections.toolkitTagline.bitbucket",
  salesforce: "settings.connections.toolkitTagline.salesforce",
  intercom: "settings.connections.toolkitTagline.intercom",
  zendesk: "settings.connections.toolkitTagline.zendesk",
  shopify: "settings.connections.toolkitTagline.shopify",
  stripe: "settings.connections.toolkitTagline.stripe",
};

const SLUG_PATTERN_RULES: ReadonlyArray<{ pattern: RegExp; key: MessageKey }> = [
  {
    pattern: /gmail|outlook|mail|smtp|imap|postmark|sendgrid/,
    key: "settings.connections.toolkitTagline.email",
  },
  {
    pattern: /calendar|calendly|schedule|scheduling/,
    key: "settings.connections.toolkitTagline.calendar",
  },
  {
    pattern: /slack|discord|teams|telegram|whatsapp|sms|twilio|message|chat|mattermost/,
    key: "settings.connections.toolkitTagline.messaging",
  },
  {
    pattern: /github|gitlab|bitbucket|jira|linear|asana|trello|clickup|monday|youtrack/,
    key: "settings.connections.toolkitTagline.workTracking",
  },
  {
    pattern: /notion|confluence|wiki|coda|doc/,
    key: "settings.connections.toolkitTagline.docs",
  },
  {
    pattern: /sheet|excel|airtable|snowflake|bigquery|postgres|mysql|database|warehouse/,
    key: "settings.connections.toolkitTagline.data",
  },
  {
    pattern: /drive|dropbox|box|onedrive|s3|storage|file|sharepoint/,
    key: "settings.connections.toolkitTagline.files",
  },
  {
    pattern: /hubspot|salesforce|crm|pipedrive|zoho|close/,
    key: "settings.connections.toolkitTagline.crm",
  },
  {
    pattern: /stripe|paypal|invoice|billing|accounting|quickbooks|xero|brex/,
    key: "settings.connections.toolkitTagline.finance",
  },
  { pattern: /figma|canva|sketch|design/, key: "settings.connections.toolkitTagline.design" },
  { pattern: /zoom|meet|webex|whereby|video/, key: "settings.connections.toolkitTagline.meetings" },
  {
    pattern: /openai|anthropic|claude|gemini|llm|ai_|_ai/,
    key: "settings.connections.toolkitTagline.ai",
  },
];

/** i18n key for the muted capability line under a connector card title. */
export function toolkitTaglineKey(slug: string): MessageKey {
  const normalized = slug.trim().toLowerCase();
  const exact = SLUG_TAGLINE_KEYS[normalized];
  if (exact) return exact;
  for (const rule of SLUG_PATTERN_RULES) {
    if (rule.pattern.test(normalized)) return rule.key;
  }
  return "settings.connections.toolkitTagline.default";
}
